export default async function getProductsBySkus(skus, token) {
  try {
    const response = await fetch(`${process.env.REACT_APP_ASSET_URL}/products/sku/by-skus`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ skus }),
    });
    return await response.json();
  } catch (err) {
    console.error("getProductsBySkus error:", err);
    return null;
  }
}
